import { FIELDS } from './constants';

const defaultFields = [  
  {
    key: 'Id',
    field: FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'Name',
    field: FIELDS.NAME,
    title: ' Name',
    label: 'Name',
    cell: 'navigation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AccountId',
    field: FIELDS.ACCOUNT_ID,
    title: ' Account Id',
    label: 'AccountId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Company Name',
    label: 'Company Name',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Address1',
    field: FIELDS.ADDRESS1,
    title: ' Address 1',
    label: 'Address 1',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Address2',
    field: FIELDS.ADDRESS2,
    title: ' Address 2',
    label: 'Address 2',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Address3',
    field: FIELDS.ADDRESS3,
    title: ' Address 3',
    label: 'Address 3',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'City',
    field: FIELDS.CITY,
    title: ' City',
    label: 'City',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'State',
    field: FIELDS.STATE,
    title: ' State',
    label: 'State',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ZipCode',
    field: FIELDS.ZIP_CODE,
    title: ' Zip Code',
    label: 'ZipCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CountryCode',
    field: FIELDS.COUNTRY_CODE,
    title: ' Country Code',
    label: 'CountryCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Country',
    field: FIELDS.COUNTRY,
    title: ' Country',
    label: 'Country',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Phone',
    field: FIELDS.PHONE,
    title: ' Phone',
    label: 'Phone',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ContactName',
    field: FIELDS.CONTACT_NAME,
    title: ' Contact Name',
    label: 'ContactName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'FullAddress',
    field: FIELDS.FULL_ADDRESS,
    title: ' Full Address',
    label: 'FullAddress',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'DateCreated',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'IsDefault',
    field: FIELDS.IS_DEFAULT,
    title: ' Is Default',
    label: 'IsDefault',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
